var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAngleDownSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1384 5.13823C4.87805 5.39858 4.45594 5.39858 4.19559 5.13823L0.862254 1.8049C0.601904 1.54455 0.601904 1.12244 0.862254 0.862091C1.1226 0.601742 1.54471 0.601742 1.80506 0.862091L4.66699 3.72402L7.52892 0.862091C7.78927 0.601742 8.21138 0.601742 8.47173 0.862091C8.73208 1.12244 8.73208 1.54455 8.47173 1.8049L5.1384 5.13823Z",
    fill: "#4B5768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAngleDownSmallIcon);
export default __webpack_public_path__ + "static/media/arrow-angle-down-small-icon.515050b552e5c8dcc4656db71e350153.svg";
export { ForwardRef as ReactComponent };